import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { AnalyticsService } from 'src/app/analytics.service';
import { AgentService } from 'src/app/service/agent.service';
import { NotificationService } from 'src/app/service/notification.service';
import { LogoutService } from 'src/app/service/logout.service';
import { Router } from '@angular/router';
import { Token } from 'src/app/manager/token';
import { ProjectandpriorityService } from 'src/app/service/projectandpriority.service';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/app/service/login.service';
import { AgentInboxMappingService } from 'src/app/service/agent-inbox-mapping.service';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuComponent } from '../menu/menu.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, TooltipModule, PanelMenuModule, MenuModule, ButtonModule, SplitButtonModule, MenuComponent]
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input('title') title: string;
  @Input('activeReasonBucket') activeReasonBucket: string;
  @Input('isCiiNRALogo') isCiiNRALogo: boolean;
  @Output() Toggle = new EventEmitter<any>();
  @Input('MenuName') MenuName: string;
  showHeader = true;
  showExitMessage = false;
  ResponseHelper: ResponseHelper;
  UserData = null;
  Token;
  ClientId = 0;
  projectList = [];
  projectListStatus = false;
  btndis: boolean = false
  //for My-Inbox
  isMyInbox = true;
  @Output() inbox = new EventEmitter<any>();
  instructionCount: any;
  @Input('clientInstructionRestriction') clientInstructionRestriction: boolean;
  role: any;
  RouteName: string;
  items: MenuItem[] | undefined;
  DisplayMenu: boolean = false;
  constructor(
    private notificationservice: NotificationService,
    public route: Router,
    private analyticsService: AnalyticsService,
    private logoutService: LogoutService,
    private agentservice: AgentService,
    private projectandpriorityService: ProjectandpriorityService,
    public loginservice: LoginService,
    private agentInboxService: AgentInboxMappingService
  ) {
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
    this.Token = new Token(this.route);
    this.agentservice.instructionCountForMarquee.subscribe(value => {
      this.instructionCount = value;
    });

  }

  ngOnInit() {

    this.UserData = this.Token.GetUserData();
    this.role = this.UserData.Role;
    if (this.UserData && this.UserData.Clients && this.UserData.Clients.length > 0) {
      this.ClientId = this.UserData.Clients[0].Client_Id;
      // this.getInitials(this.UserData.Full_Name);
      if (this.route && this.route.url == '/agent/agent') {
        this.getPNPProjectList(); // commented for now
      }
    }
    this.items = [
      { label: this.UserData.Full_Name ,styleClass: 'User-label' },
      { label: '['+this.role+']', styleClass: 'role-label' },
      { separator: true },
      {
        label: 'Reset Password',
        icon: 'pi pi-key',
        command: () => this.callMethod('Reset Password')
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.callMethod('Logout')
      }
    ];

  }


  callMethod(severity: string) {
    if (severity == 'Logout') {
      this.Logout();
    } else if (severity == 'Reset Password') {
      this.OpenMenu('change-password');
    }
  }

  /**
   * Toggle menu visibility on click
   */
  ToggleMenu(): void {
    this.DisplayMenu = !this.DisplayMenu;
  }

  ngOnChanges(changes) {
    // console.log('header component changes : ', changes);
    if (this.route && this.route.url == '/agent/agent') {
      this.getPNPProjectList();
    }
  }

  getInitials(fullName: string): string {
    if (!fullName) return '';

    const words = fullName
      .trim()
      .split(/\s+/)   // handles multiple spaces
      .filter(w => w.length > 0);

    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }

    const first = words[0].charAt(0);
    const last = words[words.length - 1].charAt(0);

    return (first + last).toUpperCase();
  }


  hideHeader() {
    // console.log('hideHeader() : ', this.showHeader);
    if (this.showHeader == true || this.showHeader == null) { this.showHeader = false; }
    this.setExitMessage(true);
    localStorage.setItem('showHeader', 'false');
    setTimeout(() => {
      // this.setExitMessage(false);
    }, 2000);
  }

  setExitMessage(status) {
    // console.log('setExitMessage : ', status);
    this.showExitMessage = status;
  }

  Logout() {
    // console.log('Logout() :')
    this.analyticsService.logOutEvent('Login/Logout').subscribe((response) => {
      console.log('logEvent : ', response);
    }, (error) => {
      console.log('logEvent : ', error);
    });
    // this.LogoutFromSystem();
    if (this.route.url == '/agent/agent' || this.route.url == '/agent/agent-inbox-mapping') {
      var logId = 0;
      var logIdPnp = 0;
      if (sessionStorage.length > 1) {
        var acc = JSON.parse(sessionStorage.getItem('Accounts'))
        var pnpAcc = JSON.parse(sessionStorage.getItem('pnpAccounts'))
        if (acc && acc.length != 0) {
          acc.forEach(e => {
            if (e.Processed == 'Working') {
              logId = e.Inventory_Log_Id ? e.Inventory_Log_Id : 0;
            }
          });
        }
        // for PNP Accounts
        if (pnpAcc && pnpAcc.length > 1) {
          pnpAcc.forEach(e => {
            if (e.Processed == 'Working') {
              logIdPnp = e.PNP_Inventory_Log_Id;
            }
          });
        }
        if (logIdPnp != null && logIdPnp != 0) {
          this.EndCurrentPNPAccount(logIdPnp);
        }

        // for Accounts
        if (logId != null && logId != 0) {
          if (this.route.url == '/agent/agent-inbox-mapping') {
            this.EndCurrentInboxAccount(logId)
          } else {
            this.EndCurrentAccount(logId);
          }
        }
        else {
          this.LogoutFromSystem();
        }
      }
      else {
        this.LogoutFromSystem();
      }

    }
    else if (this.route.url == '/supervisor/supervisor-agent') {
      var LogDetails;
      if (sessionStorage.length > 1) {
        LogDetails = JSON.parse(sessionStorage.getItem('WorkingLog'));
        if (LogDetails == null) {
          this.LogoutFromSystem()
        } else {
          this.ClientId = LogDetails.Client_Id;
          var Inventory_Log_Id = LogDetails.Inventory_Log_Id ? LogDetails.Inventory_Log_Id : 0;
          this.EndCurrentAccount(Inventory_Log_Id);
        }
      }
      else {
        this.LogoutFromSystem();
      }
    }
    else {
      this.LogoutFromSystem();
    }

  }

  EndCurrentAccount(logId) {
    var formobj = {
      Client_Id: this.ClientId,
      Inventory_Log_Id: logId
    }
    var endTimeInventory;
    let bucket_Name = sessionStorage.getItem('Accounts') != null ? JSON.parse(sessionStorage.getItem('Accounts'))[0].Bucket_Name : '';
    if (bucket_Name.indexOf('Rework_Queue') != -1) {
      endTimeInventory = this.agentservice.insertEndTimeOfReworkInventory(formobj);
    } else {
      endTimeInventory = this.agentservice.InsertEndTimeOfInventory(formobj)
    }
    // console.log('EndCurrentAccount : ', formobj)
    endTimeInventory.subscribe(
      res => {
        sessionStorage.removeItem("Accounts");
        this.LogoutFromSystem();
      },
      err => {
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }

  LogoutFromSystem() {
    // var objs = new Object();
    // const User_Id = this.UserData.UserId;
    // objs["Id"] = User_Id;
    this.logoutService.Logout({ Id: this.UserData.UserId }).subscribe(res => {
      // this.Toggle.emit(false);
      setTimeout(() => {
        this.route.navigate(['/login']);
      }, 1000);
      // this.ResponseHelper.GetSuccessResponse(res);
    },
      err => {
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }
  openProjectAndPriorityModal() {
    if (this.projectListStatus == false) {
      this.projectandpriorityService.showProjectModal = true;
    }
    // {
    //   this.notificationservice.ChangeNotification([{ Message: "Please wait, data project list is in progress!", Type: "INFO" }])
    // }
  }
  getPNPProjectList() {
    // console.log('userdata : ', this.UserData);
    if (this.UserData) {
      const { Clients, Employee_Code } = this.UserData;
      this.projectListStatus = true;
      this.projectandpriorityService.getProjectList(Clients[0].Client_Id, Employee_Code).subscribe((response: any) => {
        // console.log('getProjectList response : ', response);
        this.projectList = response.Data;
        this.projectListStatus = false;
        // this.ResponseHelper.GetSuccessResponse(response);
      }, (error) => {
        // console.log('error : ', error);
        this.projectList = [];
        this.projectListStatus = false;
        // this.ResponseHelper.GetFaliureResponse(error);
      });
    }

  }

  EndCurrentInboxAccount(logId) {
    var formobj = {
      Client_Id: this.ClientId,
      Inbox_Inventory_Log_Id: logId
    }
    // console.log('EndCurrentAccount : ', formobj)
    this.agentInboxService.InsertEndTimeOfInboxInventory(formobj).subscribe(
      res => {
        sessionStorage.removeItem("Accounts");
        this.LogoutFromSystem();
      },
      err => {
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }

  EndCurrentPNPAccount(logId) {
    var formobj = {
      Client_Id: this.ClientId,
      PNP_Inventory_Log_Id: logId
    }
    // console.log('EndCurrentAccount : ', formobj)
    this.projectandpriorityService.InsertEndTimeOfPNPInventory(formobj).subscribe(
      res => {
        sessionStorage.removeItem("pnpAccounts");
        this.LogoutFromSystem();
      },
      err => {
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }
  openInboxModal() {
    // this.title = 'Agent Inbox'
    // this.isMyInbox = false;
    // this.inbox.emit();
    this.projectListStatus = true;

    this.agentInboxService.getAgentcategory(this.ClientId).subscribe(
      (response: any) => {
        // console.log(response, "getAgentcategory data");
        // this.Buckets = response.Data.Category_Info;
        if (response && response.Data.Category_Info != null) {
          this.route.navigate(['/agent/agent-inbox-mapping']);
          // this.ResponseHelper.GetSuccessResponse(response)
        } else {
          this.ResponseHelper.GetFaliureResponse(
            {
              "Message": [
                {
                  "Message": "Category not found",
                  "Type": "ERROR"
                }
              ],
              "status": null
            }
          );
        }
        this.projectListStatus = false;

      },
      (error) => {
        this.ResponseHelper.GetFaliureResponse(error);
        this.projectListStatus = false;

      }
    );
  }

  getInstructionCount() {

    this.agentservice.GetCount(this.ClientId).subscribe((res: any) => {
      this.instructionCount = res.Data.Count;
    }, err => {
      this.instructionCount = 0;

    })


  }



  OpenMenu(menu) {
    this.RouteName = this.role.toLowerCase().replace(' ', '') + '/' + menu;
    this.Toggle.emit(false);
    // if (subMenu.Route == 'bi-report') {
    //   this.openBIReport(subMenu);
    //   return false;
    // }
    if (menu == "change-password") {
      this.route.navigate(['/' + menu]);
    } else {
      this.route.navigate([this.role.toLowerCase().replace(' ', '') + '/' + menu]);
    }
  }


}
